import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO, SelectDeeplinkDO } from '../../../../../../system/system-dtos';
import { BlastV2Service } from '../../../../../views/main-table-v2/service/blast-v2.service';

@Component({
  selector: 'app-form-field-deeplink',
  templateUrl: './deeplink-form-field.component.html',
  standalone: false,
})
export class DeeplinkFormFieldComponent extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  rowData: any;

  selected: SelectDeeplinkDO;

  deeplinks: SelectDeeplinkDO[] = [];

  linkData: any;

  fields: FieldConfigDTO[];

  selectedFieldConfig: FieldConfigDTO;

  linkId: any;

  hasFormData: boolean = false;

  constructor(private blastService: BlastV2Service) {
    super();
  }

  ngOnInit() {
    this.blastService.getCollectionObservable('deeplink').subscribe((list) => {
      this.deeplinks = list.sort((a: SelectDeeplinkDO, b: SelectDeeplinkDO) => {
        if (a.displayOrder > b.displayOrder) {
          return 1;
        }
        if (a.displayOrder < b.displayOrder) {
          return -1;
        }
        return 0;
      });

      if (this.data !== undefined) {
        this.onDeeplinkChange(
          this.data.deeplink ? this.data.deeplink : this.data,
          new MatOptionSelectionChange(null, true),
          this.rowData.linkData ? this.rowData.linkData : this.rowData.details.linkData
        );
      }
    });
  }

  onDeeplinkChange(deeplink: SelectDeeplinkDO, $event: MatOptionSelectionChange, linkData) {
    if (!$event.isUserInput || (this.selected && deeplink.id === this.selected.id)) {
      return;
    }
    this.selected = deeplink;
    this.formGroup.get(this.fieldConfig.name).setValue(this.selected);
    this.linkId = deeplink ? deeplink.id : null;

    this.fields = [];
    if (this.selected && this.selected.formConfig) {
      this.selected.formConfig.forEach((row) => {
        if (row.columns !== undefined) {
          row.columns.forEach((column) => {
            if (column.fields !== undefined) {
              column.fields.forEach((f) => {
                this.fields.push(f);
                this.hasFormData = true;
              });
            }
          });
        } else {
          this.hasFormData = false;
        }
      });
    }

    if (linkData !== undefined && !(Object.keys(linkData).length === 0 && linkData.constructor === Object)) {
      this.linkData = linkData;
    } else {
      this.linkData = deeplink.dataTemplate;
    }
    this.selectedFieldConfig = { name: 'linkData', label: 'Deeplink', type: 'criteria' } as FieldConfigDTO;
    this.selectedFieldConfig.innerFields = this.fields;
  }

  setRowData(entity: any) {
    this.rowData = entity;
  }

  ngOnDestroy() {}
}
